import { render } from "./DetailView.vue?vue&type=template&id=4cdab43d&scoped=true&ts=true"
import script from "./DetailView.vue?vue&type=script&lang=ts"
export * from "./DetailView.vue?vue&type=script&lang=ts"

import "./DetailView.vue?vue&type=style&index=0&id=4cdab43d&lang=css"
import "./DetailView.vue?vue&type=style&index=1&id=4cdab43d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdab43d"]])

export default __exports__